<template>
  <Transition>
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex h-full items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
    >
      <div class="relative mx-4 h-1/3 w-full rounded-lg bg-primary p-6 text-white">
        <h2 class="mb-4 mt-12 text-center text-lg font-semibold">{{ title }}</h2>
        <p class="mb-6 text-center text-sm text-gray-400">
          {{ message }}
        </p>

        <!-- Botões -->
        <div class="bottom-2 flex justify-between gap-4">
          <VButton
            :disabled="false"
            type="outline"
            title="Cancelar"
            v-if="closable"
            :callback="closeModal"
          />
          <VButton :disabled="false" type="solid" :title="confirmText" :callback="confirmAction" />
        </div>

        <!-- Botão de fechar -->
        <button
          class="absolute right-2 top-2 text-gray-400 hover:text-gray-300"
          @click="closeModal"
        >
          <span class="sr-only">Fechar</span>
          <span>✕</span>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import VButton from '../Button/VButton.vue'

// Props para receber o estado, título e mensagem
withDefaults(
  defineProps<{
    isOpen: boolean
    title: string
    message: string
    closable?: boolean
    confirmText?: string
  }>(),
  {
    closable: true,
    confirmText: 'Confirmar'
  }
)

const emit = defineEmits(['close', 'confirm'])

async function closeModal() {
  emit('close')
}

async function confirmAction() {
  emit('confirm')
}
</script>

<style lang="css" scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
